import { postNewProviders } from '../api/postNewProviders';

export const setPostNewProviders = (params, callback) => {
    return async (dispatch, getState) => {
        try {
            await postNewProviders(params);
            if (callback) {
                alert('Сохранено')
                callback();
            }
        } catch (error) {
            alert('Ошибка')
            console.log(error)
        }
    }
}